import Vue from "vue";
import VueRouter from "vue-router";
import { isTokenValid } from "@/utils/jwt";
import Account from "../views/Account.vue";
import Admin from "../views/Admin.vue";
import Dashboard from "../layouts/Dashboard.vue";
import Clients from "../layouts/Clients.vue";
import Sponsorship from "../layouts/Sponsorship.vue";
import Coach from "../layouts/Coach.vue";
import Subscriptions from "../layouts/Subscriptions.vue";

//Protocols pages
import Protocols from "../layouts/Protocols.vue";
import ProtocolsList from "@/components/Admin/Protocols/List.vue";
import ProtocolsExercise from "@/components/Admin/Protocols/Exercise.vue";

// Meals pages
import Meals from "../layouts/Food.vue";
import MealsList from "@/components/Admin/Food/List.vue";
import MealsAttributions from "@/components/Admin/Food/Attribution.vue";
import MealsCategories from "@/components/Admin/Food/Categories.vue";

//Session pages
import Session from "@/layouts/Session.vue";
import SessionList from "@/components/Admin/Session/List.vue";
import SessionAttributions from "@/components/Admin/Session/Attribution.vue";

//Transactions page
import Transactions from "@/layouts/Transactions.vue";

//FAQ page
import Faq from "@/layouts/Faq.vue";

// Gestion modules
import Depenses from "@/layouts/Depenses.vue";
import Stock from "@/layouts/Stock.vue";
import Fournisseurs from "@/layouts/Fournisseurs.vue";
import Chat from "@/layouts/Chat.vue";
import Rappels from "@/layouts/Rappels.vue";
import Salles from "@/layouts/Salles.vue";

Vue.use(VueRouter);

const routes = [
	{
		path: "/",
		name: "account",
		component: Account,
		meta: { public: true },
	},
	{
		path: "/admin",
		name: "admin",
		component: Admin,
		children: [
			{
				path: "/admin",
				name: "Dashboard",
				component: Dashboard,
			},
			{
				path: "/clients",
				name: "Clients",
				component: Clients,
			},
			{
				path: "/parrainages",
				name: "Sponsorship",
				component: Sponsorship,
			},
			{
				path: "/coachs",
				name: "Coaches",
				component: Coach,
			},
			{
				path: "/abonnements",
				name: "Subscriptions",
				component: Subscriptions,
			},
			{
				path: "/protocoles",
				component: Protocols,
				children: [
					{
						path: "liste",
						name: "protocols-list",
						component: ProtocolsList,
					},
					{
						path: "exercices",
						name: "protocols-exercise",
						component: ProtocolsExercise,
					},
				],
			},
			{
				path: "/repas",
				component: Meals,
				children: [
					{
						path: "liste",
						name: "meals-list",
						component: MealsList,
					},
					{
						path: "attributions",
						name: "meals-attributions",
						component: MealsAttributions,
					},
					{
						path: "categories",
						name: "meals-categories",
						component: MealsCategories,
					},
				],
			},
			{
				path: "/seances",
				component: Session,
				children: [
					{
						path: "liste",
						name: "session-list",
						component: SessionList,
					},
					{
						path: "attributions",
						name: "session-attributions",
						component: SessionAttributions,
					},
				],
			},
			{
				path: "/transactions",
				name: "Transactions",
				component: Transactions,
			},
			{
				path: "/faq",
				name: "Faq",
				component: Faq,
			},
			{
				path: "/depenses",
				name: "Depenses",
				component: Depenses,
			},
			{
				path: "/stock",
				name: "Stock",
				component: Stock,
			},
			{
				path: "/fournisseurs",
				name: "Fournisseurs",
				component: Fournisseurs,
			},
			{
				path: "/chat",
				name: "Chat",
				component: Chat,
			},
			{
				path: "/rappels",
				name: "Rappels",
				component: Rappels,
			},
			{
				path: "/salles",
				name: "Salles",
				component: Salles,
			},
		],
	},
];

const router = new VueRouter({
	mode: "history",
	base: process.env.BASE_URL,
	routes,
});

// ─── Navigation Guard JWT ────────────────────────────────────────────────────
router.beforeEach((to, from, next) => {
	const isPublic = to.meta?.public === true;
	const token = localStorage.getItem("token");

	// Route publique (login) — si déjà connecté, rediriger vers le dashboard
	if (isPublic) {
		if (token && isTokenValid(token)) {
			return next({ path: "/admin", replace: true });
		}
		return next();
	}

	// Route protégée — vérifier le token
	if (!token || !isTokenValid(token)) {
		localStorage.removeItem("token");
		localStorage.removeItem("venue");
		localStorage.removeItem("venueId");
		return next({ path: "/", replace: true });
	}

	next();
});

export default router;
